import { createSelector } from 'reselect';
import { getType } from 'typesafe-actions';
import { actions } from '..';
import { toObject } from '../../data-utils';
import { Identifier, QueueRegionId, Squad } from '../../model';
import { Actions, StoreState } from '../types';

type Squads = null | Record<string, Squad>

function makeKey(id:  Identifier) {
  return `[${id.server}][${id.id}]`
}

export default function squads(state: Squads = null, action: Actions): Squads {
  switch (action.type) {
    case getType(actions.fetchQueues.response): {
      if (action.payload.region !== QueueRegionId.Squads) {
        return state
      }

      return toObject(action.payload.squads, t => makeKey(t), t => t)
    }
    case getType(actions.deleteSquad): {
      if (state) {      
        const { [makeKey(action.payload.squad)]: _, ...newState } = state
        return newState
      }
      return state
    }
    case getType(actions.addSquad): {
      const newState = { ...state ?? {}, [makeKey(action.payload.squad)]: action.payload.squad }
      return newState
    }
    case getType(actions.updateSquad): {
      const newState = { ...state ?? {}, [makeKey(action.payload.squad)]: action.payload.squad }
      return newState
    }
  }

  return state
}

function getRoot(state: StoreState) {
  return state.squads
}

export const selectSquads = createSelector(
  getRoot,
  squads => {
    return squads && Object.values(squads)
  })

export function selectSquad(state: StoreState, squadId: Identifier) {
  const squads = getRoot(state)
  return squads && squads[squadId.id] || null
}
